<div *ngIf="display == enumTimeLineDisplay.Default" class="card-header d-flex">

    <h4 class="flex-grow-1 pt-2" i18n="@@">Recent Activity</h4>
    <div *ngIf="displayDropdownButton" style="display: flex; justify-content: end;" ngbDropdown>
        <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" style="top: -0.5rem;"
            aria-expanded="false" class="btn btn-soft-info arrow-none display: flex; justify-content: end;"
            ngbDropdownToggle>
            <span> Actions</span> <i class="ri-more-2-fill align-bottom"></i>
        </button>
        <ul aria-labelledby="dropdownMenuLink1" ngbDropdownMenu>
            <li class="p-2">
                <button *ngIf="securityPermissionTimelineCreateNote" style="width: 100%;" (click)="newNote()"
                    class="btn btn-soft-primary" i18n="@@"> Create
                    Note</button>
            </li>
        </ul>
    </div>
</div>
<div *ngIf="display == enumTimeLineDisplay.Dashboardside " class="mb-2 col-12 " style=" 
    overflow-y : scroll; overflow-x :hidden; ">
    <ng-container class="p-1" style="max-height: 300px !important;" *ngTemplateOutlet="accordian"></ng-container>
</div>

<div *ngIf="display != enumTimeLineDisplay.Dashboardside ">


    <div *ngIf="isLoadingVal"
        style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <div *ngIf="isNotListLoaded" class="rounded" style="height: 200px; text-align: center; ">
    </div>

    <div *ngIf="display == enumTimeLineDisplay.Default else elseList" class="col-12 " style="    max-height: 1040px !important; border-bottom: 1px solid var(--vz-border-color);
    overflow-y : scroll; overflow-x :hidden; ">

        <ng-container class="p-1" *ngTemplateOutlet="accordian"></ng-container>
    </div>
    <div *ngIf='display == enumTimeLineDisplay.Default && timeLineListService.pageSize < timeLineListService.totalRecords'
        class="m-2 mb-3">
        <div class="rounded" style=" text-align: center; ">
            <button class="btn btn-soft-info text-success mt-2 fs-16" style=" padding-left: 25px; padding-right: 25px; "
                id="loadmore" (click)="loadMore(timeLineListService)">Load More </button>
        </div>
    </div>
    <ng-template #elseList>
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-template>
</div>
<ng-template #list>
    <div class="card border shadow-none border-solid" id="contactList" style="overflow: scroll; scrollbar-width: none;">
        <div class="card-body" style="padding-bottom: 0px ;">

            <div class="table-card  ">

                <table class="table align-middle table-nowrap">

                    <thead class="text-muted bg-soft-light ">
                        <tr>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Title</span>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Date Created</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Created By</span>

                                </div>
                            </th>
                            <th>
                                <div class="d-flex" style="cursor:default">
                                    <span class="flex-grow-1 " i18n="@@">Actions</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="list form-check-all">
                        <tr *ngFor="let data of listItems" id="i_{{data.id}}">
                            <td>
                                <div class="flex-grow-1">
                                    <div *ngIf="!data.name">
                                        New Timeline Item
                                    </div>
                                    <div *ngIf="data.name">
                                        {{data.name}}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex">
                                    <span class=" flex-grow-1">{{data.modifiedDate}}</span>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class=" flex-shrink ">{{data.createdByUserName}}</div>
                                </div>
                            </td>

                            <td>
                                <div class=" d-flex ">
                                    <div class="ps-3" style="padding-top: 0.5rem;">
                                        <button
                                            *ngIf="((data.type == enumTimeLineType.Note) && securityPermissionTimelineCreateNote )else elseViewButton"
                                            [disabled]="submitted" class="dropdown-item edit-item-btn"
                                            style="cursor:pointer" data-bs-toggle="modal"
                                            (click)="openNote(data, false)"><i
                                                class="ri-edit-line align-bottom me-2 text-muted"></i>
                                            Edit</button>

                                        <ng-template #elseViewButton>

                                            <button [disabled]="submitted" class="dropdown-item edit-item-btn"
                                                style="cursor:pointer" data-bs-toggle="modal"
                                                (click)="openNote(data, true)"><i
                                                    class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                View</button>

                                        </ng-template>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>
</ng-template>

<ng-template #accordian>
    <div class=" align-items-center order-status profile-timeline " *ngFor="let data of listItems" id="i_{{data.id}}">
        <ngb-accordion [closeOthers]="false" class="accordion" role="tablist" #acc="ngbAccordion" activeIds="static-1"
            aria-multiselectable="false">


            <ngb-panel id="static-1" class="accordion-item ">

                <ng-template ngbPanelTitle>
                    <a class="accordion-button shadow-none show w-100 " data-bs-toggle="collapse"
                        href="javascript:void(0);" aria-controls="collapseOne">
                        <div class="d-flex position-relative show" style="  z-index: 2;">

                            <div class="flex-shrink-0 ms-3 mt-2 justify-content-center" style="z-index: 20; ">
                                <div class="d-flex align-middle justify-content-center"
                                    style="background-color: #ed5e5e;; border-radius: 25px; width: 28px; height: 28px; ">
                                    <span style=" font-size: 18px; color: var(--vz-white);">
                                        <i *ngIf="data.type== enumTimeLineType.Note" class="ri-file-list-2-fill"></i>
                                        <i *ngIf="data.type== enumTimeLineType.Email" class="mdi mdi-email"></i>
                                        <i *ngIf="data.type!=enumTimeLineType.Note && data.type!=enumTimeLineType.Note"
                                            class="ri-exchange-funds-line"></i>
                                    </span>
                                </div>
                            </div>
                            <div style="
                            border-left: 2px dashed var(--vz-border-color);
                            margin-left: -0.95rem;
                            top: 0;
                            z-index: 10;">
                            </div>

                            <div class="ms-4 pt-2 flex-grow-1">
                                <h6 *ngIf="!data.name" class="fs-14 mb-1">
                                    New Timeline Item
                                </h6>
                                <h6 *ngIf="data.name" class="fs-14 mb-1">
                                    {{data.name}}
                                </h6>
                                <small *ngIf="display == enumTimeLineDisplay.Dashboardside && data.tags" class=" mb-1">
                                    {{data.tags[0]}}
                                </small>
                                <small class="text-muted d-flex">
                                    <span class=" flex-grow-1">{{data.modifiedDate | amTimeAgo}}</span>

                                </small>
                            </div>
                        </div>
                    </a>
                </ng-template>
                <ng-template ngbPanelContent class="show">

                    <div class="show" style="visibility: visible; border-left: 2px dashed var(--vz-border-color)">
                        <div class="ms-4" style="padding-top: 0.5rem;">

                            <button class="btn badge bg-light text-primary fs-12 "
                                *ngIf="((data.type == enumTimeLineType.Note) && securityPermissionTimelineCreateNote )else elseViewButton"
                                [disabled]="submitted" style="cursor:pointer" data-bs-toggle="modal"
                                (click)="openNote(data, false)"><i
                                    class="ri-edit-line align-bottom me-2 text-muted"></i>
                                Edit</button>

                            <ng-template #elseViewButton>

                                <button [disabled]="submitted" class="btn badge bg-light text-primary fs-12 "
                                    style="cursor:pointer" data-bs-toggle="modal" (click)="openNote(data, true)"><i
                                        class="ri-eye-fill align-bottom me-2 text-muted"></i>
                                    View</button>

                            </ng-template>


                        </div>
                        <div class="ms-4" style="padding-top: 0.5rem;" aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample">

                            <span>
                                <small class="text-muted ">
                                    <div class=" flex-shrink ">Created by: {{data.createdByUserName}}</div>
                                </small>

                                <div *ngIf="data.description" class="fs-13 text-muted" style="cursor:pointer"
                                    (click)="showText(data)">
                                    <span
                                        [ngStyle]="{'white-space': (data.showOverFlowText == true) ? 'wrap': 'nowrap' } "
                                        style=" display: block; overflow: hidden; ">
                                        <app-rich-text-displayer class="text-muted mb-0"
                                            [textToDisplay]="data.description"></app-rich-text-displayer>
                                    </span>
                                </div>
                            </span>

                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>


</ng-template>